/**
 * @fileOverview Menu Bar
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Local:scrollToTop
 * @requires Github:lodash-es/throttle
 * @requires Polyfill:element-prototype-classlist 'Element.classList'
 */

import scrollToTop from '../../../00-utilities/scroll-to-top';
import throttle from 'lodash-es/throttle';

/**
 * @module MenuBar
 */

export default {
  /**
   * Init the menuBar
   * @method initialization
   */
  initialization() {
    if ( document.querySelector( '.ac-menu-bar--social' )) {
      this.menuTitle = document.querySelector( '.ac-menu-bar__message-text' );

      const firstTitle = document.querySelector( 'h1' );

      // H1 in Header
      if ( this.menuTitle && firstTitle ) {
        this.menuTitle.innerHTML = firstTitle.innerText
      }
    }

    this.menuBar = document.querySelector( '.ac-menu-bar' );

    if ( this.menuBar ) {
      window.addEventListener( 'scroll', throttle(() => {
        this.fix(), this.toggleButton()
      }, 300 ));

      const btnToTop = document.querySelector( '.ac-menu__btn-to-top' );

      if ( btnToTop ) {
        btnToTop.addEventListener( 'click', ( e ) => {
          e.preventDefault();
          scrollToTop();
        })
      }
    }
  },

  /**
   * Add Position fixed to the menu-bar
   */
  fix() {
    if ( window.pageYOffset > 80 ) {
      this.menuBar.classList.add( 'js-is--displayed' );
    } else {
      this.menuBar.classList.remove( 'js-is--displayed' );
    }
  },

  /**
  * Toggle Button To Top
  * @function toggleButton
  */
  toggleButton() {
    let menu = document.querySelector( '.ac-menu__btn-to-top' ),
      lastScroll;

    if ( menu ) {
      // If attribute is detected
      if ( menu.hasAttribute( 'data-scroll' )) {
        lastScroll = menu.getAttribute( 'data-scroll' );

        if ( window.pageYOffset < lastScroll && window.pageYOffset > 80 ) {

          // If window is smaller than 768px cancel menutop and if template is
          // free-call, call or social
          if ( window.matchMedia( '(max-width:768px)' ).matches &&
              ( document.querySelector( '.ac-menu-bar--free-call' ) ||
                document.querySelector( '.ac-menu-bar--call' ) ||
                document.querySelector( '.ac-menu-bar--social' )
              )
          ) {
            // Cancel menu toggle
            return false;
          }
          menu.classList.add( 'js-btn-is--displayed' );
        } else {
          menu.classList.remove( 'js-btn-is--displayed' );
        }
      }

      // Set new scroll value
      menu.setAttribute( 'data-scroll', window.pageYOffset );
    }
  }
}
